import React from "react";
import styled from "styled-components";
const SocialNetwork = styled.a `
  background-color: var(--bs-lime-green);
  color: var(--bs-forest-green);
  width: 60px;
  height: 60px;
  transition: background-color .25s ease, color .25s ease;
  &:hover {
    background-color: var(--bs-forest-green);
    color: var(--bs-lime-green);
  }
`;
const SocialLink = ({url, name, children}) => {

  return url && name && (
    <SocialNetwork className="p-10 d-flex align-items-center justify-content-center" target="_blank" rel="noopener" href={url} aria-label={name}>
      {children}
    </SocialNetwork>
  )
}

export default SocialLink;
